var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],staticClass:"grid",attrs:{"transition-duration":"0.3s","item-selector":".item"}},[_c('div',{staticClass:"grid-sizer"}),_vm._l((_vm.blocks),function(item,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item"},[_c('img',{attrs:{"src":("/img/dog" + (item.id) + ".jpg")}})])})],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30229f7c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GaLife.vue
// module id = null
// module chunks = 